<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="true"
                                id="ki"
                                size="xl"
                                title="DUBBELE KLANTEN SAMENVOEGEN">
    <snelstart-ui-dialog-body>

        <snelstart-ui-dialog-header-content>
            <div>
                <b>Let op! 'Dubbele klanten samenvoegen' is alleen van belang als er sprake geweest is van het samenvoegen van klantenlijsten uit
                    SnelStart Relaties en SnelStart Dossiers of het importeren van klanten uit andere (fiscale) pakketten. </b><br/><br/>
                Staan er na het samenvoegen dubbele klanten (relaties) in de lijst? Geen probleem, je kunt ze eenvoudig samenvoegen en alle gegevens bewaren. Kies het klantnummer dat je wilt behouden en kies het klantnummer dat je wilt archiveren. Alle aangiften, rapporten en dossiers worden zichtbaar bij het behouden klantnummer.<br/>
                Klanten uit de Dossiers-klantenlijst (voor aangiften etc.) kun je samenvoegen
                met dezelfde klant uit de Relatie-klantenlijst (binnen Polaris) en daarna archiveren. Om fouten te
                voorkomen kunnen klanten uit de Relatie-klantenlijst hier niet gearchiveerd worden. Je kunt ze uiteraard wel selecteren voor 'Behouden'.<br/>
                Lees meer over het samenvoegen van klanten op ons <a
                    href="https://kennisplein.snelstart.nl/snelstartpolaris/klanten-samenvoegen"
                    target="_blank">Kennisplein</a>.
            </div>
        </snelstart-ui-dialog-header-content>

        <!--        <snelstart-ui-alert [showIcon]="false" type="danger">-->
        <!--            <div style="font-size: 14px">-->

        <!--                <b>Werkwijze samenvoegen klanten</b><br/>-->

        <!--                <ol style="line-height: 1.8;">-->
        <!--                    <li><strong>Sluit </strong> dit scherm en je komt weer op het Klantenoverzicht.-->
        <!--                    </li>-->
        <!--                    <li><strong>Zoek </strong> in het klantenoverzicht op naam om dubbele klanten te vinden. Gebruik het-->
        <!--                        veld 'Zoek klanten' rechtsboven in het klantenoverzicht.-->
        <!--                    </li>-->
        <!--                    <li><strong>Klik</strong> dan op 'Klanten samenvoegen' en keer terug in dit scherm.-->
        <!--                    </li>-->
        <!--                    <li><strong>Klik</strong> dan op 'Toon gesorteerde klanten'. De lijst met dubbele klanten (=-->
        <!--                        resultaat van zoekscherm) wordt nu getoond. <br/>Nb. Wanneer je niet gebruik maakt van het-->
        <!--                        zoekveld worden-->
        <!--                        de klanten per-->
        <!--                        pagina getoond. Dat maakt het vinden van dubbele klanten lastig.-->
        <!--                    </li>-->
        <!--                    <li><strong>Selecteer</strong> in de kolom 'Behouden' de klant die je wilt behouden (tip: de klant-->
        <!--                        met het laagste klantnummer is in veel gevallen de klant uit SnelStart Relaties).-->
        <!--                    </li>-->
        <!--                    <li><strong>Kies</strong> in de kolom 'Verplaatsen' de klant(en) waarvan de gegevens moeten worden-->
        <!--                        verplaatst naar (samengevoegd met) de te behouden klant.-->
        <!--                    </li>-->
        <!--                    <li><strong>Bevestig</strong> om de klanten samen te voegen door te klikken op 'Voeg samen'. De 'te-->
        <!--                        verplaatsen' klanten worden direct uit de lijst gehaald.-->
        <!--                    </li>-->
        <!--                    <li><strong>Herhaal</strong> het voorgaande voor alle dubbele klanten.</li>-->
        <!--                </ol>-->
        <!--                <ol style="line-height: 1.8;">-->
        <!--                    <li><strong>Sluit </strong> dit scherm en je komt weer op het Klantenoverzicht.-->
        <!--                    </li>-->
        <!--                    <li><strong>Zoek </strong> in het klantenoverzicht op naam om dubbele klanten te vinden. Gebruik het-->
        <!--                        veld 'Zoek klanten' rechtsboven in het klantenoverzicht.-->
        <!--                    </li>-->
        <!--                    <li><strong>Klik</strong> dan op 'Klanten samenvoegen' en keer terug in dit scherm.-->
        <!--                    </li>-->
        <!--                    <li><strong>Klik</strong> dan op 'Toon gesorteerde klanten'. De lijst met dubbele klanten (=-->
        <!--                        resultaat van zoekscherm) wordt nu getoond. <br/>Nb. Wanneer je niet gebruik maakt van het-->
        <!--                        zoekveld worden-->
        <!--                        de klanten per-->
        <!--                        pagina getoond. Dat maakt het vinden van dubbele klanten lastig.-->
        <!--                    </li>-->
        <!--                    <li><strong>Selecteer</strong> in de kolom 'Behouden' de klant die je wilt behouden (tip: de klant-->
        <!--                        met het laagste klantnummer is in veel gevallen de klant uit SnelStart Relaties).-->
        <!--                    </li>-->
        <!--                    <li><strong>Kies</strong> in de kolom 'Verplaatsen' de klant(en) waarvan de gegevens moeten worden-->
        <!--                        verplaatst naar (samengevoegd met) de te behouden klant.-->
        <!--                    </li>-->
        <!--                    <li><strong>Bevestig</strong> om de klanten samen te voegen door te klikken op 'Voeg samen'. De 'te-->
        <!--                        verplaatsen' klanten worden direct uit de lijst gehaald.-->
        <!--                    </li>-->
        <!--                    <li><strong>Herhaal</strong> het voorgaande voor alle dubbele klanten.</li>-->
        <!--                </ol>-->

        <!--                <b>Klantgegevens</b><br/>-->
        <!--                Bij het samenvoegen van dubbele klanten worden aangiften, rapporten, dossieritems etc. bewaard bij de te-->
        <!--                behouden klant. De klant waarvan gegevens worden verplaatst vind je na samenvoegen terug bij-->
        <!--                'Gearchiveerde klanten'. Lees meer over het samenvoegen van klanten op ons <a-->
        <!--                    href="https://www.snelstart.nl/klantenservice" target="_blank">Kennisplein</a>.-->
        <!--                <br/><br/>-->
        <!--            </div>-->
        <!--        </snelstart-ui-alert>-->

        <!--    <ul class="nav nav-tabs mb-3">-->
        <!--      <li class="nav-item">-->
        <!--        <a (click)="setTab(0)" [class.active]="selectedTab === 0" class="nav-link">Samenvoegen</a>-->
        <!--      </li>-->
        <!--      <li class="nav-item">-->
        <!--        <button (click)="setTab(1)" [class.active]="selectedTab === 1" [disabled]="true" class="nav-link"></button>-->
        <!--      </li>-->
        <!--    </ul>-->
        <!--    @if (isMergeTab) {-->

        <div class="flex items-center mb-3 gap-2">
            <label class="mb-0"><b>Type hieronder (een deel van) bijv. de klantnaam</b></label>
            <input (input)="searchArchivedUsers(true)"
                   [(ngModel)]="activeSearchTerm"
                   class="form-control mt-1 w-25"
                   placeholder="Zoek dubbele klanten"
                   type="text"/>
        </div>
        <table class="table">
            <thead>
            <tr>
                <th>Behouden</th>
                <th>Archiveren</th>
                <th>Klantnummer</th>
                <th>Naam</th>
                <th>Postcode</th>
                <th>Plaats</th>
                <th>Fiscaal nummer</th>
            </tr>
            </thead>
            <tbody>
                @if (relations.results && relations.results.length) {
                    @for (result of relations.results; track result.id) {
                        <tr>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''"
                                    class="align-middle">
                                <input
                                        (click)="selectTarget(result.id)"
                                        [checked]="targetId === result.id"
                                        [value]="result.id"
                                        name="target"
                                        type="radio"
                                />
                            </td>

                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">
                                <input
                                        (change)="onToggleSourceChange($event, result.id)"
                                        [checked]="sourceIds.has(result.id)"
                                        [disabled]="targetId === result.id"
                                        type="checkbox"
                                />
                            </td>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">{{ result.code }}
                            </td>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">{{ result.name }}
                            </td>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">{{ result.postalCode }}
                            </td>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">{{ result.city || '-' }}
                            </td>
                            <td
                                    [style.background-color]="targetId === result.id ? '#23c552' : sourceIds.has(result.id) ? '#f84f31' : ''">{{ result.fiscalIdentifier }}
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
        <!--    } @if (isSplitTab) {-->
        <!--    <table class="table">-->
        <!--      <thead>-->
        <!--      <tr>-->
        <!--        <th style="width: 150px;">Huidige Klanten-->
        <!--          <input (input)="searchArchivedUsers(true)" [(ngModel)]="activeSearchTerm" class="form-control mt-1"-->
        <!--                 placeholder="Zoek actieve klanten"-->
        <!--                 type="text" />-->

        <!--        </th>-->
        <!--        <th style="width: 300px;">Items te verplaatsen</th>-->
        <!--        <th style="width: 150px;">-->
        <!--          Gearchiveerde Klanten-->
        <!--          <input (input)="searchArchivedUsers(false)" [(ngModel)]="archivedSearchTerm" class="form-control mt-1"-->
        <!--                 placeholder="Zoek gedeactiveerde"-->
        <!--                 type="text" />-->
        <!--        </th>-->
        <!--      </tr>-->
        <!--      </thead>-->
        <!--      <tbody>-->
        <!--      <tr>-->
        <!--        @if (relations.results && relations.results.length) {-->
        <!--          <tr>-->
        <!--            &lt;!&ndash; Current Users Scrollable Column &ndash;&gt;-->
        <!--            <td style="padding: 0; vertical-align: top; width: 300px;">-->
        <!--              <div style="max-height: 400px; overflow-y: auto; display: flex; flex-direction: column; padding: 0.5rem;">-->
        <!--                @for (result of relations.results; track result.id) {-->
        <!--                  <div [style.background-color]="selectedCurrentUserId === result.id ? '#23c552' : ''"-->
        <!--                       style="padding: 0.25rem;">-->
        <!--                    <input (click)="selectCurrentUser(result.id)"-->
        <!--                           [checked]="selectedCurrentUserId === result.id"-->
        <!--                           name="currentUser"-->
        <!--                           type="radio" />-->
        <!--                    {{ result.name }} ({{ result.code }})-->
        <!--                  </div>-->
        <!--                }-->
        <!--              </div>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        }-->
        <!--        <td style="padding: 0; vertical-align: top; width: 300px;">-->
        <!--          <div-->
        <!--            style="display: flex; flex-direction: column; max-height: 400px; overflow-y: auto; padding: 1rem; border: 1px solid #ccc;">-->
        <!--            @if (selectedCurrentUserId && taxItemsToShow?.length) {-->
        <!--              @for (item of taxItemsToShow; track item.key) {-->
        <!--                <div style="margin-bottom: 0.5rem;">-->
        <!--                  <input [(ngModel)]="taxSelection[item.key]"-->
        <!--                         [disabled]="!item.enabled"-->
        <!--                         type="checkbox" />-->
        <!--                  {{ item.label }}-->
        <!--                </div>-->
        <!--              }-->
        <!--              <button (click)="onSplit()"-->
        <!--                      [disabled]="!selectedCurrentUserId&&!selectedArchivedUserId"-->
        <!--                      class="btn btn-warning mt-2">Verplaats naar &#8594;-->
        <!--              </button>-->
        <!--            } @else {-->
        <!--            <div style="color: #888; text-align: center; margin-top: 2rem;">-->
        <!--              Select a user to see Tax Items-->
        <!--            </div>-->
        <!--          }-->

        <!--          </div>-->
        <!--        </td>-->
        <!--        &lt;!&ndash; Archived Users &ndash;&gt;-->
        <!--        <td style="padding: 0; vertical-align: top; width: 150px;">-->
        <!--          <div style="max-height: 400px; overflow-y: auto; display: flex; flex-direction: column; padding: 0.5rem;">-->
        <!--            @if (archivedUsers?.results?.length) {-->
        <!--              @for (archived of archivedUsers.results; track archived.id) {-->
        <!--                <div [style.background-color]="selectedArchivedUserId === archived.id ? '#23c552' : ''"-->
        <!--                     style="margin-bottom: 0.25rem; padding: 0.25rem;">-->
        <!--                  <input (click)="selectArchivedUser(archived.id)"-->
        <!--                         [checked]="selectedArchivedUserId === archived.id"-->
        <!--                         name="archivedUser"-->
        <!--                         type="radio" />-->
        <!--                  {{ archived.name }}-->
        <!--                </div>-->
        <!--              }-->
        <!--            } @else {-->
        <!--            <div style="color: #888; text-align: center; margin-top: 1rem;">-->
        <!--              No archived users-->
        <!--            </div>-->
        <!--          }-->
        <!--          </div>-->
        <!--        </td>-->
        <!--      </tr>-->
        <!--      </tbody>-->
        <!--    </table>-->
        <!--  }-->


    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <div class="d-flex flex-row align-items-center w-100">
            <div *ngIf="juisteKlanten" class="me-auto pe-5 pt-2">
                <snelstart-ui-alert type="danger">
                    LET OP! De klantnamen zijn verschillend. Zijn de juiste klanten geselecteerd?
                </snelstart-ui-alert>
            </div>
            <snelstart-ui-button
                    (click)="dialogVisibleChange.emit(false); this.targetId = undefined; this.sourceIds.clear()"
                    btn-x
                    class="me-1"
                    id="cancel"
                    type="secondary">
                <div *ngIf="showSamenvoegklanten">
                    Annuleren
                </div>
                <div *ngIf="!showSamenvoegklanten">
                    Sluiten
                </div>
            </snelstart-ui-button>
            <snelstart-ui-button
                    [config]="mergeButtonConfig"
                    [disabled]="this.targetId === undefined || this.sourceIds.size === 0"
                    icon="check"
                    id="merge"
                    ignoreClick
                    type="primary">Voeg samen
            </snelstart-ui-button>
        </div>

    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
